import { StormDoorHandleType } from '../../common/storm-door-handle-type';
import { IProductTexture, ProductTexture } from '../../common/product-texture';
import { IStormDoorHandleTypeOption, StormDoorHandleTypeOption } from '../../common/storm-door-handle-type-option';

export interface IStormDoorHandleEditingModel {
    id: string;
    isActive: boolean;
    description: string;
    productUrl: string;
    brand: string;
    handleType: StormDoorHandleType;
    imageUrl: string;
    auxImageUrls: string[];
    sellingPoints: string[];
    price: number;
    inStoreQuantity: number;
    isNotAvailable: boolean;
    pickupLeadTimeInDays: number;
    textureVariants: IProductTexture[];
    doorHandleTypes: IStormDoorHandleTypeOption[];
}


export class StormDoorHandleEditingModel implements IStormDoorHandleEditingModel {
    public id: string = '';
    public isActive: boolean = false;
    public description: string = '';
    public productUrl: string = '';
    public brand: string = '';
    public handleType: StormDoorHandleType = StormDoorHandleType.Indeterminate;
    public imageUrl: string = '';
    public auxImageUrls: string[] = [];
    public sellingPoints: string[] = [];
    public price: number = 0;
    public inStoreQuantity: number = 0;
    public isNotAvailable: boolean = false;
    public pickupLeadTimeInDays: number = 0;
    public textureVariants: IProductTexture[] = [];
    public doorHandleTypes: IStormDoorHandleTypeOption[] = [];
}


